import { useServices } from 'containers/services';
import { useQuery, type UseQueryOptions, type UseQueryResult } from 'react-query';
import { QUERY_KEYS } from 'utils/queryKeys';
import type { GetManufacturersArg, GetManufacturersResponse } from '../../../lib/services';

export const useManufacturers = (
  filter: GetManufacturersArg['filter'] = {},
  options?: UseQueryOptions<GetManufacturersResponse>,
): UseQueryResult<GetManufacturersResponse> => {
  const { manufacturersApiClient } = useServices();

  return useQuery({
    queryKey: QUERY_KEYS.manufacturers.filter(filter),
    queryFn: async ({ signal }) => await manufacturersApiClient.findAll({ filter, signal }),
    ...options,
  });
};
